import { selectAllHeaders, toHeadersRecord } from '../../state/headers.js';
import getRequestWithBoundHeaders from './getRequestWithBoundHeaders.js';
export const getPublicRequest = (client) => {
    const headers = toHeadersRecord(selectAllHeaders(client.getState()));
    return Promise.resolve(getRequestWithBoundHeaders(headers));
};
